import React from 'react';
import type { Article, SidebarHighlight, Testimonial } from '@/types';
import { Sidebar } from '@components/UI/Sidebar';
import styles from './FeatureArticle.module.css';

interface FeatureArticleProps {
  article: Article;
  sidebarHighlights: SidebarHighlight[];
  testimonial: Testimonial;
}

export const FeatureArticle: React.FC<FeatureArticleProps> = ({
  article,
  sidebarHighlights,
  testimonial
}) => {
  return (
    <section id="feature" className={styles.page}>
      <article className={styles.articleContent}>
        <h1 className={styles.articleTitle}>{article.title}</h1>
        <h2 className={styles.articleSubtitle}>{article.subtitle}</h2>
        <div className={styles.byline}>{article.byline}</div>

        <div className={styles.content}>
          {article.content.map((paragraph, index) => (
            <p key={index} className={index === 0 ? styles.firstParagraph : ''}>
              {paragraph}
            </p>
          ))}
        </div>
      </article>

      <Sidebar highlights={sidebarHighlights} testimonial={testimonial} />

      <div className={styles.pageNumber}>02</div>
    </section>
  );
};
